//const labelConfig = WizTableForm.Config.label(this, { apiParams: { type: 6, name: '产品知识库标签' } })
import React from "react";
import { framework_tool, component_tool, utils_tool } from '@/tool'
let { WizPopover, WizButton } = component_tool
import WizTableForm from "../wizTableForm";
import proKnowledgeType from "./config-proKnowledgeType";
let proKnowledgeTypeConfig = proKnowledgeType(this, { apiParams: {} });

const columns = () => {
  return [
    {
      title: "标题",
      name: "title",
      dataIndex: "title",
      searchItem: {},
      formItem: {},
      tableItem: {width:150}
    },
  
    {
      title: "知识类型",
      name: "proKnowledgeTypeTitle",
      dataIndex: "proKnowledgeTypeTitle",
      tableItem: {width:150}
    },
    {
      title: "知识类型",
      name: "proKnowledgeTypeIdList",
      searchItem: {
        ...proKnowledgeTypeConfig,
        diy: WizTableForm,
      }
    },
    {
      title: "分类",
      name: "categoryStr",
      dataIndex: "categoryStr",
      formItem: {},
      tableItem: {
        width:200,
        render: (text,record) =>{
          let contextList = text && text.split(';').length ? text.split(';') : []
          let content = [];
          let title = ''
          contextList && contextList.length && contextList.map((d,index) => {
            if (index === 0) {
              title = d
            }
            content.push(<p>{d}</p>)
          })
          let _titleView = []
          _titleView.push(title)
          if(contextList && contextList.length > 1){
            _titleView.push(<span className='wiz-press-font-color'> ...</span>)
          }
          return (
            <WizPopover content={content} placement="rightTop">
              {_titleView}
            </WizPopover>
          )
        }
      }
    },
    {
      title: "生效时间",
      name: "effectiveTimeAll",
      dataIndex: "effectiveTimeAll",
      formItem: {},
      searchItem: {
        type: 'date~',
        showTime: true
      },
    },
    {
      title: "生效时间",
      name: "effectiveTime",
      dataIndex: "effectiveTime",
      formItem: {},
      tableItem: {width:150}
    },
    {
      title: "失效时间",
      name: "failureTimeAll",
      dataIndex: "failureTimeAll",
      formItem: {},
      searchItem: {
        type: 'date~',
        showTime: true
      },
    },
    {
      title: "失效时间",
      name: "failureTime",
      dataIndex: "failureTime",
      formItem: {},
      tableItem: {width:150}
    },
    {
      title: "发布终端",
      name: "releasePlatform",
      dataIndex: "releasePlatform",
      searchItem: {
        type: "select"
        // mode: 'multiple',
      },
      dict: [
        { code: 1, codeName: "PC" },
        { code: 2, codeName: "APP" },
        { code: 3, codeName: "凯迪拉克IQ" },
       // { code: 4, codeName: "小程序" },
        { code: 5, codeName: "雪佛兰企微" },
        { code: 6, codeName: "别克企微" },
        { code: 7, codeName: "凯迪拉克企微" },
      ]
    },
    {
      title: "发布终端",
      name: "releasePlatformStr",
      dataIndex: "releasePlatformStr",
      tableItem: {width: 200,},
    },
  
   
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'proKnowledge/pageList',
    ...api
  }
}

const proKnowledge = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'id',
    rowName: 'title',
    columns: columns(),
    cols: {
      xs: 8,
      md: 8,
      xl: 8
    },
    // tableLayout:'fixed',
    // scroll:{
    //   x:1300,
    // },
    tableApi: tableApi(api)
  }
}

export default proKnowledge
